'use client';

import dynamic from 'next/dynamic';

export const StickyTrickVisualization = dynamic(
  () => import('./StickyTrickVisualization'),
  {
    ssr: true,
  }
);
